import logo from './logo.svg';
import './App.css';
import HealthCheck from "./components/HealthCheck";

function App() {
  return (
    <div>
      <h1>Еноа</h1>
      <HealthCheck />
    </div>
  );
}

export default App;
